/** @jsx jsx */
import React, {useState} from 'react';
import { css, jsx } from '@emotion/core'
import Shimmer from 'react-shimmer'
import FilterBar from './FilterBar'
import Typist from 'react-typist';

function CardLinks(props) {
    const app = props.app

    const ProductHunt = (hunt) => (
        <div key={hunt.id}>
            <a css={css`
                width: 80%;
                margin-left: 10%;
                margin-top: 20px;
            `}
                href={hunt.link}
                target="_blank"
            >
                <img css={css`
                    width: 80%;
                `}
                    src={`https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=${hunt.id}&theme=light`} />
            </a>
        </div>
    )

    const Appstore = (platform) => (
        <div key={platform.id} css={css`
            width: 200px;
            height: 60px;
            margin-left: ${platform.platform === 'macOS' ? '18%' : '23%'}
        `}>
            <a css={css`

            `}
                href={`https://apps.apple.com/app/${platform.id}`}
                target="_blank"
            >
                <img src={require(`../images/download ${platform.platform}.svg`)} />
            </a>
        </div>
    )

    const Gumroad = (gumroad) => (
        <div key={gumroad.id} css={css`
            margin-top: 10px;
            margin-bottom: 10px;
            cursor: pointer;
        `}>
            <a className="gumroad-button"
                target="_blank"
                onClick={() => {
                    const link = `https://gum.co/${gumroad.id}`
                    window.open(link)
                }}
            >
                Get my app
            </a>
        </div>
    )

    const ViewDetail = (url) => (
        <div key={url} css={css`
            margin: 10px auto;
        `}>
            <a css={css`
                box-shadow: inset 0px 39px 0px -24px #3dc21b;
                background-color: #44c767;
                border-radius: 4px;
                border: 1px solid #18ab29;
                cursor: pointer;
                color: #ffffff;
                font-size: 15px;
                padding: 6px 15px;
                text-decoration: none;
                text-shadow: 0px 1px 0px #2f6627;
                text-align: center;
                width: 150px;;
                display: inline-block;
            `}
                href={url}
            >
                View
            </a>
        </div>
    )

    let links = []
    if (app.download !== undefined) {
        if (app.download.appstore !== undefined) {
            app.download.appstore.forEach((platform) => {
                links.push(Appstore(platform))
            })
        }

        if (app.download.gumroad !== undefined) {
            links.push(Gumroad(app.download.gumroad))
        }
    }

    if (app.productHunt !== undefined) {
        links.push(ProductHunt(app.productHunt))
    }

    if (app.showcase.detail) {
        links.push(ViewDetail(`https://onmyway133.com/${app.slug}`))
    }

    if (app.web !== undefined) {
        links.push(ViewDetail(app.web.link))
    }

    return (
        <div css={css`
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-items: center;
            a:hover {
                transform: scale(1.1);
            }
            a:active {
                position: relative;
                top: 1px;
            }
        `}>
            {links}
            <div css={css`
                height: 10px;
            `}></div>
        </div>
    )
}

function Card(props) {
    const app = props.app

    const platforms = app.showcase.platforms.map((platform) => {
        return (
            <span css={css`
                padding: 4px 8px;
                background-color: #4FA9D9;
                border-radius: 4px;
                font-size: 13px;
                font-weight: 600;
                margin: 0 8px;
            `}>{platform}</span>
        )
    })

    const Content = () => (
        <div key={app.slug} >
            <div css={css`
                width: 100%;
                height: auto;
                padding: 10px 0;
                background-color: ${app.showcase.background}
            `}>
                <Shimmer css={css`
                    margin: 0 auto;
                    display: block;
                `}
                    width={180}
                    height={180}
                    src={
                        require(`../../../data/images/${app.slug}/icon.png`)
                    }
                    style={{ objectFit: 'cover' }}
                />
            </div>
            <div css={css`
                height: 150px;
                justify-content: flex-start;
                padding: 20px 0;
                p {
                    text-align: center;
                    margin: 0 10%;
                }
            `}>
                <p css={css`
                    font-weight: bold;
                    font-size: 20px;
                `}>{app.name}</p>

                <div css={css`
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    margin: 10px 0;
                `}>
                    {platforms}
                </div>

                <p css={css`
                    font-weight: 600;
                    color: #5e5e5e;
            `}>{app.showcase.tagline}</p>
            </div>
        </div>
    )

    return (
        <div css={css`
            width: 240px;
            box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.2);
            border-radius: 8px;
            margin: 20px;
            overflow: hidden;
            transition: all .25s ease-in-out;
            &:hover {
                transform: scale(1.1);
                div.card-links {
                    display: block;
                    background-color: rgba(100, 100, 100, 0.5);
                }

                div.content {
                    filter: blur(3px);
                }
            }

            position: relative;
        `}>
            <div className="content">
                <Content />
            </div>

            <div css={css`
                display: none;
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
            `} className="card-links">
                <CardLinks app={app} />
            </div>
        </div>
    )
}

export default function Showcase(props) {
    const factory = props.factory
    const [state, setState] = useState(
        {
            factory,
            selectedFilter: { name: '' }
        }
    )

    const onFilterClick = (filter) => {
        setState({
            selectedFilter: filter,
            factory: (() => {
                if (filter.name === 'All') {
                    return factory
                } else {
                    return factory.filter((app) => {
                        return app.showcase.platforms.includes(filter.name)
                    }) 
                }
            })()
        })
    }

    let cards = state.factory.map((app, index) => {
        return (
            <Card app={app} key={app.slug} />
        )
    })

    return (
        <div css={css`
            margin-top: 10em;
        `}>
            <Typist css={css`
                text-align: center;
                font-size: 25px;
                margin-bottom: 5em;
                font-style: italic;
            `}
            >
                Simple apps that make sense
            </Typist>
            <FilterBar onClick={onFilterClick} />
            <div css={css`
                display: grid;
                grid-template-columns: repeat(auto-fit, 250px);
                grid-gap: 30px;
                padding: 0 8vw;
            `}>
                {cards}
            </div>
        </div>

    )
}